import { z } from "zod";

/**
 * Common ID Parameter Schema
 */
export const IdParamSchema = z.object({ id: z.string().min(1) });
export type IdParamDTO = z.infer<typeof IdParamSchema>;

/**
 * Lookup Query Schema (for combobox/search)
 */
export const LookupQuerySchema = z.object({
  q: z
    .string()
    .trim()
    .transform((v) => (v && v.length > 0 ? v : undefined))
    .optional(),
  limit: z.coerce.number().int().min(1).max(100).default(20),
  skip: z.coerce.number().int().min(0).default(0),
});
export type LookupQueryDTO = z.infer<typeof LookupQuerySchema>;
